module.exports = __webpack_public_path__ + "img/stop-line.3b512aad.jpg";